module.exports = __webpack_public_path__ + "static/media/parallax-form-9.18b38aff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/parallax/parallax-form-9.svg
// module id = 1713
// module chunks = 146